import {externalApiURL} from '@logistics-frontend/client-core/api/corp'
import type {Optional} from '@logistics-frontend/types'
import {addQuery} from '@logistics-frontend/utils'

import type {NddClaimOffersInfoQuery, NddClaimOffersRequest, NddClaimOffersResponse} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

export function fetchOffersInfoDeprecated(
  body: NddClaimOffersRequest,
  query: NddClaimOffersInfoQuery,
): Promise<Optional<NddClaimOffersResponse>> {
  return fetch<NddClaimOffersRequest, NddClaimOffersResponse, NddClaimOffersResponse>({
    url: addQuery(externalApiURL('platform/integration/v1/offers/info'), {...query, country: appConfig.countryCode}),
    method: 'post',
    body,
  })
}
